import script from "./PreWithEllipsis.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreWithEllipsis.vue?vue&type=script&setup=true&lang=ts"

import "./PreWithEllipsis.vue?vue&type=style&index=0&id=bee13f3a&lang=scss"

const __exports__ = script;

export default __exports__